import React, { FC } from 'react';

import { formatCurrencyValue } from '@eika/currency-input';
import { Loader } from '@eika/loader';

import { BorettslagAndelWeb, MatrikkelWeb } from '../../generated-types';
import { useGetFellesgjeld } from '../../hooks/useEiendom';
import { useTranslation } from '../../translations';

interface Props {
    adresse: string;
    erSelveier: boolean;
    andel: BorettslagAndelWeb | undefined;
    matrikkel: MatrikkelWeb | undefined;
}
const TypeBoligInfo: FC<Props> = ({ adresse, erSelveier, andel, matrikkel }) => {
    const { boligAdresseInfo } = useTranslation();
    const {
        data: fellesgjeld,
        isStale,
        isLoading,
    } = useGetFellesgjeld(andel?.andelsnummer, andel?.organisasjonsnummer) || 0;

    if (isLoading && isStale) {
        return <Loader mini />;
    }

    return (
        <>
            {erSelveier && (
                <div className="info-box row-gap">
                    <span className="title">{adresse}</span>
                    <span>
                        <span>{boligAdresseInfo.matrikkel}</span>
                        <span className="bold" key="t">
                            {matrikkel?.kommunenr}/{matrikkel?.gaardsnummer}/{matrikkel?.bruksnummer}/
                            {matrikkel?.festenummer}/{matrikkel?.seksjonsnummer}
                        </span>
                    </span>
                    <span>
                        <span>{boligAdresseInfo.typeBolig}</span>
                        <span className="bold">{boligAdresseInfo.selveier}</span>
                    </span>
                </div>
            )}
            {andel && (
                <div className="info-box row-gap">
                    <span className="title">{andel?.foretaksnavn}</span>
                    <span>
                        <span>{boligAdresseInfo.orgNr} </span>
                        <span className="bold"> {andel?.organisasjonsnummer} </span>
                    </span>
                    <span>
                        <span>{boligAdresseInfo.andelsnummer} </span>
                        <span className="bold"> {andel?.andelsnummer} </span>
                    </span>
                    <span>
                        <span>{boligAdresseInfo.typeBolig}</span>
                        <span className="bold">{boligAdresseInfo.borettslag}</span>
                    </span>
                    {!isStale && (
                        <span>
                            <span>{boligAdresseInfo.fellesgjeld}</span>
                            <span className="bold">{`${formatCurrencyValue(Number(fellesgjeld?.toFixed()) || 0)} kr`}</span>
                        </span>
                    )}
                </div>
            )}
        </>
    );
};

export default TypeBoligInfo;
